import getChartColorsArray from '../../../../Common/ChartsDynamicColor';
import React from 'react';
import ReactApexChart from 'react-apexcharts';



const SimplePie = ({ dataColors }:any) => {
    const chartPieBasicColors = getChartColorsArray(dataColors);
    const series = [44, 55, 13, 43, 22]
    const options:any = {
        chart: {
            height: 300,
            type: 'pie',
        },
        labels: ['Taze Gida', 'Kasap', 'Meyve Sebze', 'Alkol', 'Temizlik'],
        legend: {
            position: 'bottom'
        },
        dataLabels: {
            dropShadow: {
                enabled: false,
            }
        },
        colors: chartPieBasicColors
    };
    return (
        <>
        
       <ReactApexChart
                dir='ltr'
            className="apex-charts"
            series={series}
            options={options}
            type="pie"
            height="300px"
        />
        
        </>
    )
}
export default SimplePie;